import React from 'react';

import './ArticlesArticlePage.css';
import API from "../../components/api";
import {withRouter} from "../../layouts/AdminLayout/AdminLayout";
import {SERVER_URL} from "../../config";
import Utils from "../../utils";


class ArticlesArticlePage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            article: {
                content: ''
            },
            articles: [],
            isLoaded: false
        }
    }

    componentDidMount() {
        API.getArticlesArticlePage(this.props.params.articleId)
            .then(data => this.setState({article: data, isLoaded: true}, () => {
                try {
                    Utils.setPageTitle(data.title)
                } catch (e) {
                }
            }))
            .catch(() => {
            })
    }

    render() {
        const {article} = this.state;

        return <div className='article-page'>
            <div className='page'>
                {
                    this.state.isLoaded ?
                        <div className='article'>
                            <div className='about'>
                                <div className='date'>
                                    {article.published_date}
                                </div>
                                <div className='title'>
                                    {article.title}
                                </div>
                                <div className='subtitle'>
                                    {article.subtitle}
                                </div>
                                <img src={SERVER_URL + article.image} alt=''/>
                            </div>
                            <div className='content' dangerouslySetInnerHTML={{__html: article.content}}/>
                        </div> : null
                }

            </div>
        </div>
    }
}


export default withRouter(ArticlesArticlePage);
